<ng-container *transloco="let t">
  <app-loader [loading]="loading === true"></app-loader>
  <form (submit)="onSubmit()" novalidate>
    <div class="p-grid p-fluid statistics-filter" *ngIf="loading !== true">
      <div class="p-col-4">
        <div class="p-grid">
          <div class="p-col">
            <app-form-control [cid]="'template'" [control]="form.get('template')" [type]="'select'" [label]="t('common.labels.procedure')" [options]="optionsTemplates" optionLabel="name" [filter]="true" [showClear]="true"></app-form-control>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-6">
            <app-form-control [cid]="'start'" [control]="form.get('start')" [type]="'date'" [label]="t('common.labels.start')" [showTime]="false" [minDate]="minDate"></app-form-control>
          </div>
          <div class="p-col-6">
            <app-form-control [cid]="'end'" [control]="form.get('end')" [type]="'date'" [label]="t('common.labels.end')" [showClear]="true" [showTime]="false" [minDate]="minDate"></app-form-control>
          </div>
        </div>
      </div>
      <div class="p-col-8">
        <div class="p-grid">
          <div class="p-col-6">
            <app-form-control [cid]="'locations'" [control]="form.get('locations')" [type]="'multiselect'" [label]="t('common.labels.locations')" [showAllSelected]="true" [options]="optionsLocations" optionLabel="name" [showClear]="true"></app-form-control>
          </div>
          <div class="p-col-6">
            <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-6">
            <app-form-control [cid]="'roles'" [control]="form.get('roles')" [type]="'multiselect'" [label]="t('common.labels.roles')" [showAllSelected]="true" [options]="optionsRoles" optionLabel="label" [showClear]="true"></app-form-control>
          </div>
          <div class="p-col-6">
            <app-form-control [cid]="'languages'" [control]="form.get('languages')" [type]="'multiselect'" [label]="t('common.labels.languages')" [showAllSelected]="true" [options]="optionsLanguages" optionLabel="name" [showClear]="true"></app-form-control>
          </div>
        </div>
      </div>
      <div class="p-col-4">
        <button pButton type="button" [label]="t('common.labels.clear_filters')" (click)="onResetForm()" class="p-button-outlined" style="max-width: 180px;"></button>
      </div>
      <div class="p-col-4 p-offset-4 p-text-right">
        <button pButton type="submit" [label]="t('common.labels.show_results')" [disabled]="form.valid ? null : true" style="max-width: 180px;"></button>
      </div>
    </div>
  </form>
</ng-container>
